import {computed} from 'vue';
import {useUrlSearchParams} from '@vueuse/core';

/**
 * URL-gestützter Arbeitsdokument-Zustand (pro Tab konfliktfrei, überlebt Reload). Aus
 * useMusicUploadStore extrahiert – die einzige Quelle der ?file/?semitones/?lineage/?entry/
 * ?document/?reuse-Parameter. Dauerhafte Persistenz liegt in der Dateihistorie (IndexedDB).
 */
export function useWorkingDocUrlState() {
    const urlParams = useUrlSearchParams<{
        file?: string;
        semitones?: string;
        lineage?: string;
        reuse?: string;
        entry?: string;
        document?: string;
    }>('history');

    function takeReuseId(): string | null {
        const id = (urlParams.reuse as string) || null;
        if (id) delete urlParams.reuse;
        return id;
    }

    const currentFileId = computed<string | null>({
        get: () => (urlParams.file as string) || null,
        set: (value) => {
            if (value) urlParams.file = value;
            else delete urlParams.file;
        },
    });

    const transposedSemitones = computed<number>({
        get: () => Number(urlParams.semitones ?? 0) || 0,
        set: (value) => {
            if (value) urlParams.semitones = String(value);
            else delete urlParams.semitones;
        },
    });

    const lineageId = computed<string>({
        get: () => (urlParams.lineage as string) || '',
        set: (value) => {
            if (value) urlParams.lineage = value;
            else delete urlParams.lineage;
        },
    });

    const currentEntryId = computed<string | null>({
        get: () => (urlParams.entry as string) || null,
        set: (value) => {
            if (value) urlParams.entry = value;
            else delete urlParams.entry;
        },
    });

    const activeDocumentId = computed<string | null>({
        get: () => (urlParams.document as string) || null,
        set: (value) => {
            if (value) urlParams.document = value;
            else delete urlParams.document;
        },
    });

    return {currentFileId, transposedSemitones, lineageId, currentEntryId, activeDocumentId, takeReuseId};
}
